import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { UserPermissions } from "./../../../../models/domains/pbm/user/user-permissions";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { Toast } from "./../../../toast/toast";
import { LoadingService } from "./../../../../services/loading.service";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { UserService } from "./../../../../services/user.service";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { User } from "src/app/ui/models/domains/pbm/user/user";
import { AppContext } from "src/app/ui/contexts/app-context";
import { UntypedFormControl } from "@angular/forms";

@Component({
  selector: "search-user",
  templateUrl: "./search-user.component.html",
  styleUrls: ["./search-user.component.scss"],
})
export class SearchUserComponent implements OnInit {
  pageableResult = new PageableResult();
  nameControl = new UntypedFormControl();

  constructor(
    private featureViewService: FeatureViewService,
    private userService: UserService,
    private loadingService: LoadingService,
    private toast: Toast,
    private router: Router,
    private appContext: AppContext,
  ) {}

  async ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.UserSearchFeatureView, PageViews.UserPageView);
    this.searchUserByName();
  }

  async searchUserByName() {
    const ref = this.loadingService.beginLoading();
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(1);
    pagingRequest.setEnd(this.appContext.getTotalPerPage());
    pagingRequest.setFilterText(this.nameControl.value);
    try {
      const result = await this.userService.searchUser(pagingRequest);
      this.pageableResult.setStart(pagingRequest.getStart());
      this.pageableResult.setEnd(pagingRequest.getEnd());
      this.pageableResult.setTotalItems(result.getTotalItems());
      this.pageableResult.setItems(result.getItems());
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  async searchMoreUsers() {
    const ref = this.loadingService.beginLoading();
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(this.pageableResult.getEnd() + 1);
    pagingRequest.setEnd(this.appContext.getTotalPerPage());
    pagingRequest.setFilterText(this.nameControl.value);
    try {
      const result = await this.userService.searchUser(pagingRequest);
      this.pageableResult.setStart(pagingRequest.getStart());
      this.pageableResult.setEnd(pagingRequest.getEnd());
      this.pageableResult.setTotalItems(result.getTotalItems());
      this.pageableResult.addItems(result.getItems());
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  showMoreUsersBtn(): boolean {
    return this.pageableResult && this.pageableResult.getTotalItems() !== this.pageableResult.getItems().length && this.pageableResult.getItems().length > 1;
  }

  goToEditUser(user: User): void {
    this.router.navigate([RoutePath.RegisterUser, user.getUserKey()]);
  }

  hasAccessToEditUser(): boolean {
    return this.userService.getLoggedUser().hasPermission(UserPermissions.EditUser);
  }

  isResultEmpty(): boolean {
    return this.pageableResult && this.pageableResult.getItems().length === 0;
  }
}
